import { Flex, Text } from "@/atoms"
import { Code } from "@/molecules/Code"
import { CLIENT_ID_PLACEHOLDER } from "./AppRegistrationSteps.constants"
import { AppRegistrationValue } from "./AppRegistrationValue"
import { useAppRegistrationTranslation } from "./useAppRegistrationTranslation"

import type { ThreatDetectionProps } from "./AppRegistrationSteps.types"

// Where Copilot Studio asks Kodem before a tool call, as the app
export const ThreatDetection = ({
  preInstall,
  clientId
}: ThreatDetectionProps) => {
  const t = useAppRegistrationTranslation()

  return (
    <Flex vertical gap={8}>
      <Text>
        {t("threatDetection", {
          clientId: clientId.trim() || CLIENT_ID_PLACEHOLDER
        })}
      </Text>
      <Code.CommandCard>
        <AppRegistrationValue
          label={t("url")}
          value={preInstall.threatDetectionUrl}
        />
      </Code.CommandCard>
    </Flex>
  )
}
